<template>
  <div class="early-checkin-view">
    <div class="cnt-top-title m-b-10">
      <span class="cnt-title">订单信息</span>
      <div class="title-extra">
        <span class="form-label">预订人：</span>
        <span>{{ formData.bookerName }}</span>
        <span class="span-phone">{{ formData.bookerPhone }}</span>
      </div>
    </div>
    <div class="cnt-content m-b-10">
      <el-row :gutter="20">
        <el-col :span="12">
          <span class="form-label">订单编码：</span>
          <span>{{ formData.roomCode }}</span>
        </el-col>
        <el-col :span="12">
          <span class="form-label">房源名称：</span>
          <span>{{ formData.roomName }}</span>
        </el-col>
      </el-row>
    </div>
    <div class="cnt-top-title m-b-10">
      <span class="cnt-title">入住信息</span>
    </div>
    <div class="cnt-content highlight m-b-10">
      <el-row class="m-b-15" :gutter="20">
        <el-col :span="24">
          <span class="form-label">原预抵时间：</span>
          <span>{{ formData.proposedCheckInTime }}</span>
        </el-col>
      </el-row>
      <el-row class="m-b-15" :gutter="20">
        <el-col :span="24">
          <span class="font-16">新预抵时间：</span>
          <el-date-picker v-model="newProposedCheckInTime" :disabledDate="getDisabledDate" format="YYYY-MM-DD HH:mm" type="datetime" :clearable="false" />
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="flex">
            <span class="font-18">房费：</span>
            <span v-if="!isEditPrice" class="font-price">￥{{ formData.orderPrice }}</span>
            <el-input-number v-else v-model="newOrderPrice" :min="0" controls-position="right" />
            <el-button class="font-btn-blue" icon="Edit" type="text" @click="isEditPrice = !isEditPrice">{{ isEditPrice ? '取消修改' : '手动修改' }}</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="bottom-btn">
      <el-button class="submit-btn" :loading="saveLoading" @click="handleConfirm">保存</el-button>
      <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Moment from 'moment'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isEditPrice: false,
      saveLoading: false,

      newOrderPrice: 0,
      newProposedCheckInTime: '',
    }
  },
  created() {
    this.initFormData()
  },
  watch: {
    show(val) {
      if (val) {
        this.initFormData()
      }
    }
  },
  methods: {
    ...mapActions([ 'fetchData' ]),
    // 获取禁用日期时间
    getDisabledDate(date) {
      let day = date.getDate()
      let proDate = new Date(this.formData.proposedCheckInTime)
      let preProDate = new Date((+proDate) - 24 * 60 * 60 * 1000)
      if (day === proDate.getDate() || day === preProDate.getDate()) {
        return false
      }

      return true
    },
    // 初始化数据
    initFormData() {
      this.isEditPrice = false
      this.newOrderPrice = this.formData.orderPrice || 0
      this.newProposedCheckInTime = this.formData.proposedCheckInTime
    },
    // 校验时间
    valideProTime() {
      let nProTime = +(new Date(this.newProposedCheckInTime))
      let oProTime = +(new Date(this.formData.proposedCheckInTime))
      if (nProTime > oProTime) {
        this.$message.warning('新预抵时间不能比原预抵时间晚！')
        return false
      }
      if (oProTime - nProTime > 24 * 60 * 60 * 1000) {
        this.$message.warning('新预抵时间不能超过24小时！')
        return false
      }
      return true
    },
    // 处理确认
    handleConfirm() {
      if (!this.valideProTime()) return

      let url = 'ORDER.POST_EARLY_CHECK_IN'
      let params = {
        id: this.formData.id,
        proposedCheckInTime: Moment(this.newProposedCheckInTime).format('YYYY-MM-DD HH:mm'),
      }
      if (this.isEditPrice) {
        params.orderPrice = this.newOrderPrice
      }
      this.saveLoading = true

      this.fetchData({ url, method: 'post', params, flag: true, headers: { 'Content-Type': 'application/json' } }).then(res => {
        if (res.code === 200) {
          this.$message.success('操作成功！')
          this.$emit('success')
        } else {
          this.$message.error(res.msg || '操作失败！')
        }
      }).catch(err => {
        this.$message.error(err || '操作失败！')
      }).finally(() => {
        this.saveLoading = false
      })
    },
    // 处理取消
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less" scoped>
.early-checkin-view {
  color: black;
}
.cnt-top-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .cnt-title {
    font-size: 18px;
    color: #333;
  }
  .title-extra {
    span {
      margin-left: 10px;
    }
    .span-phone {
      color: rgb(55, 146, 215);
    }
  }
}
.form-label {
  color: #959697;
}
.cnt-content {
  padding: 15px 20px;
  background-color: rgb(245, 245, 245);
  border-radius: 3px;
  &.highlight {
    background-color: rgb(241, 250, 255);
  }
}
.font-price {
  font-size: 24px;
  font-weight: bold;
  color: rgb(235, 66, 66);
}
.font-btn-blue {
  color: rgb(0, 192, 192);
}
.bottom-btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: 10px;
  width: 100%;
}
.flex {
  display: flex;
  align-items: center;
}
</style>